"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicSnapshotConnectionQuery = exports.dynamicSnapshotConnectionMetadataQuery = void 0;
const template_1 = require("./template");
// Based on the generated query
const dynamicSnapshotConnectionMetadataQuery = (pageNumber) => `
snapshotConnection(page: ${pageNumber}) {
  snapshots {
    id
    description
    createdAt
    createdBy
  }
  nextPage
}
`;
exports.dynamicSnapshotConnectionMetadataQuery = dynamicSnapshotConnectionMetadataQuery;
const dynamicSnapshotConnectionQuery = (pageNumber) => `
snapshotConnection(page: ${pageNumber})  {
  snapshots {
    id
    description
    createdAt
    createdBy
    ${template_1.templateQuery}
  }
  nextPage
}
`;
exports.dynamicSnapshotConnectionQuery = dynamicSnapshotConnectionQuery;
